import WidgetHeaderWide, { Props as ImportedProps } from './WidgetHeaderWide';

export default WidgetHeaderWide;
export type Props = ImportedProps;
